import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronDown = (props) => {
    if (process.env.NODE_ENV !== "production") {
        if (props["aria-hidden"] !== "true" &&
            props["aria-label"] === undefined) {
            console.warn('aria-hidden="true" or aria-label should be passed to svg icon for better user experience. Use aria-label="" if you have reason to do so.');
        }
    }
    return (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 448 512", "data-svgtype": "icon-default", ...props, children: _jsx("path", { d: "M432.6 209.3 241.5 392.4c-6.4 5.4-12.4 7.6-17.5 7.6s-11.97-2.219-16.59-6.688L15.41 209.3c-9.596-9.1-9.908-25.2-.72-33.9 9.125-9.625 24.38-9.938 33.91-.719L224 342.8l175.4-168c9.5-9.219 24.78-8.906 33.91.719 9.19 8.581 8.89 24.681-.71 33.781z" }) }));
};
export default SvgChevronDown;
